import { put, fork, call, takeEvery, all } from 'redux-saga/effects';
import app from '../../app';
import { loadUserCompletion } from '../../actions';

export function* watchLoadUser() {
  yield takeEvery('LOAD_USER', function*({ userId }) {
    const options = {
      url: `/api/user/${userId}`,
    };
    const result = yield call(app.httpFetch, options);
    yield put(loadUserCompletion(userId, result.error, result.data));
  });
}

export default function* userSaga() {
  yield all([fork(watchLoadUser)]);
}
